import Button from '@mui/material/Button';
import { makeThemedStyles } from '@qpr/components/utils';
import React from 'react';

const useStylesForTabs = makeThemedStyles('ToggleButtonGroup.ToggleButton', theme => ({
  ToggleButton: {},
  disabled: {},
  inactive: {
    backgroundColor: theme.palette.grey[400]
  }
}));

type PropType = React.ComponentProps<typeof Button> & { inactive?: boolean };

export const ToggleButton: React.FunctionComponent<PropType> = (props: PropType) => {
  const styles = useStylesForTabs();
  const { inactive, ...res } = props;
  return (
    <Button
      {...res}
      className={styles.ToggleButton}
      classes={{
        root: inactive ? styles.inactive : styles.ToggleButton,
        disabled: styles.disabled
      }}
    >
      {props.children}
    </Button>
  );
};
export default ToggleButton;
